import { type OnDemandItem } from "@ca.vmedia.tv/domains";
import { CardDataType, type ImageCardData, type PlayCardData, ComponentName } from "../types";

export class EpisodeCardData implements ImageCardData, PlayCardData {

    private item: OnDemandItem;
    private idx: number;
    private pos: number;

    constructor(item: OnDemandItem, idx: number) {
        this.item = item;
        this.idx = idx;
        this.pos = 0;
    }

    getId(): string {
        return `${this.item.id}`;
    }

    getImage(): string {
        return this.item.image ?? "";
    }

    getPlayItem(): OnDemandItem {
        return this.item;
    }

    getClass(): string {
        return 'episode-card'
    }

    getType(): number {
        return CardDataType.OnDemand;
    }

    getContentType() {
        return `${this.item.contentType}`;
    }

    getComponentName(): ComponentName {
        return ComponentName.EPISODE;
    }

    setPosition(pos: number): void {
        this.pos = pos;
    }

    getStreamPosition(): number {
        return this.pos;
    }

    getName(): string {
        return `${this.item?.episodeNum ?? this.idx+1}. ${this.item?.shortName ?? this.item?.name ?? ""}`;
    }
}
